(function () {
  'use strict';

  if (window.__sessionInterceptorInstalled) {
    return;
  }
  window.__sessionInterceptorInstalled = true;

  let isRedirecting = false;

  function handleSessionExpired() {
    if (isRedirecting) {
      return;
    }
    isRedirecting = true;
    window.location.href = '/Auth/LogOut';
  }

  function isSameOrigin(rawUrl) {
    if (!rawUrl) {
      return true;
    }
    try {
      return new URL(rawUrl, window.location.href).origin === window.location.origin;
    } catch (_) {
      return false;
    }
  }

  function checkResponseForSessionExpired(status, headers) {
    if (
      status === 401 ||
      (typeof headers.get === 'function' && headers.get('X-Session-Expired') === '1')
    ) {
      handleSessionExpired();
      return true;
    }
    return false;
  }

  // --- Fetch wrapper ---

  const originalFetch = window.fetch;

  window.fetch = async function () {
    const args = arguments;
    const rawUrl = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? args[0]?.href);

    if (!isSameOrigin(rawUrl)) {
      return originalFetch.apply(this, args);
    }

    const response = await originalFetch.apply(this, args);

    checkResponseForSessionExpired(response.status, response.headers);

    return response;
  };

  // --- XMLHttpRequest wrapper (instrument-on-instance) ---
  // Each new instance is a real native XHR with a readystatechange
  // listener added in the constructor. No prototype mutation.

  const NativeXHR = window.XMLHttpRequest;

  function InstrumentedXHR() {
    const real = new NativeXHR();

    real.addEventListener('readystatechange', function () {
      if (real.readyState === 4) {
        const url = real.responseURL || '';
        if (isSameOrigin(url)) {
          checkResponseForSessionExpired(real.status, {
            get(name) {
              return real.getResponseHeader(name);
            },
          });
        }
      }
    });

    return real;
  }

  window.XMLHttpRequest = InstrumentedXHR;

  // --- jQuery global handler (catches any case the XHR wrapper misses) ---

  if (window.jQuery) {
    jQuery(document).ajaxError(function (event, jqXHR) {
      if (!isSameOrigin(jqXHR.responseURL)) {
        return;
      }
      checkResponseForSessionExpired(jqXHR.status, {
        get(name) {
          return jqXHR.getResponseHeader(name);
        },
      });
    });
  }
})();
